import React, { useEffect, useState } from "react";
import { FaList } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import "./Header.css";
import { useNavigate } from "react-router";
import { jwtDecode } from "jwt-decode";
import secureLocalStorage from "react-secure-storage";

function Header() {
  let navigate = useNavigate();
  const [isMobileNavActive, setIsMobileNavActive] = useState(false);
  const [userDetails, setUserDetails] = useState(null);

  // Decode the JWT token and set user details
  const updateUserDetails = () => {
    const token =
      localStorage.getItem("token") || secureLocalStorage.getItem("token");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setUserDetails(decodedToken);
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    } else {
      setUserDetails(null);
    }
  };

  useEffect(() => {
    updateUserDetails(); // Initial fetch of user details
    window.addEventListener("userDetailsUpdated", updateUserDetails);

    return () => {
      window.removeEventListener("userDetailsUpdated", updateUserDetails);
    };
  }, []);

  const toggleMobileNav = () => {
    setIsMobileNavActive(!isMobileNavActive);
  };

  const closeMobileNav = () => {
    setIsMobileNavActive(false);
  };

  const handleDropdownToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const parentLi = event.target.closest("li.dropdown");
    if (parentLi) {
      parentLi.classList.toggle("dropdown-active");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    secureLocalStorage.removeItem("token");
    secureLocalStorage.removeItem("user");
    secureLocalStorage.removeItem("userId");
   
    const event = new Event("userDetailsUpdated"); // Trigger a custom event
    window.dispatchEvent(event);
    closeMobileNav();

    navigate("/"); // Redirect to home
  };

  const renderDashboardLink = () => {
    if (!userDetails) {
      return (
        <li
          className="login-hbtn"
          onClick={() => {
            navigate("/login");
            closeMobileNav();

          }}
        >
          <span>Login</span>
        </li>
      );
    }

    switch (userDetails.role) {
      case "ADMIN":
        return (
          <li
            className="login-hbtn"
            onClick={() => {
              navigate("/admin-dashboard");
              closeMobileNav();

            }}
          >
            <span>Admin Dashboard</span>
          </li>
        );
      case "VENDOR":
        return (
          <li
            className="login-hbtn"
            onClick={() => {
              navigate("/vendor-dashboard");
              closeMobileNav();

            }}
          >
            <span>Vendor Dashboard</span>
          </li>
        );
      case "CO-ORDINATOR":
        return (
          <li
            className="login-hbtn"
            onClick={() => {
              navigate("/co-ordinator-dashboard");
              closeMobileNav();

            }}
          >
            <span>Event Coordinator Dashboard</span>
          </li>
        );
      case "USER":
        return (
          <>
            <li
              className="login-hbtn"
              onClick={() => {
                navigate("/user-dashboard");
                closeMobileNav();

              }}
            >
              <span>User Dashboard</span>
            </li>
            <li className="login-hbtn" onClick={handleLogout}>
              <span>Logout</span>
            </li>
          </>
        );
      default:
        return (
          <li
            className="login-hbtn"
            onClick={() => {
              navigate("/login");
              closeMobileNav();

            }}
          >
            <span>Login</span>
          </li>
        );
    }
  };

  return (
    <div id="header">
      <header
        className={`header d-flex align-items-center fixed-top ${
          isMobileNavActive ? "mobile-nav-active" : ""
        }`}
      >
        <div className="container-fluid container-xl position-relative d-flex align-items-center">
          <a href="/" className="logo d-flex align-items-center me-auto">
            <img
              className="ceplogo"
              src="/assets/Images/logo.png"
              alt="cep-logo"
            />
            <div className="logo-text d-flex align-items-center">
              <h1 className="sitename">CEP</h1>
              <div className="company-details align-items-center">
                <p className="company-name">
                  COSMICAL EVENT PLANNERS PRIVATE LIMITED
                </p>
                <p className="tagline">BUILDING CONFIDENCE, DELIVERING TRUST</p>
              </div>
            </div>
          </a>
          <nav
            id="navmenu"
            className={`navmenu ${
              isMobileNavActive ? "mobile-nav-active" : ""
            }`}
          >
            <ul>
              <li className="dropdown">
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/");
                    closeMobileNav();
                  }}
                >
                  Home
                </a>
              </li>
              <li className="dropdown">
                <a
                  href="/About"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/About");
                    closeMobileNav();
                  }}
                >
                  About Us
                </a>
              </li>
              <li className="dropdown">
                <a
                  href="/contact-us"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/contact-us");
                    closeMobileNav();
                  }}
                >
                  Contact Us
                </a>
              </li>
              <li className="dropdown">
  <a
    href="/Vendor-Categorys"
    onClick={(e) => {
      e.preventDefault();
      navigate("/Vendor-Categorys");
      closeMobileNav();
    }}
  >
    Vendors
  </a>
</li>

              {renderDashboardLink()}
            </ul>
          </nav>
          <i
            className={`mobile-nav-toggle d-xl-none bi ${
              isMobileNavActive ? "bi-x" : "bi-list"
            }`}
            onClick={toggleMobileNav}
          >
            {isMobileNavActive ? <RxCross2 /> : <FaList />}
          </i>
        </div>
      </header>
    </div>
  );
}

export default Header;
